import { render } from "./TheTeachers.vue?vue&type=template&id=391a71a3&scoped=true&ts=true"
import script from "./TheTeachers.vue?vue&type=script&lang=ts"
export * from "./TheTeachers.vue?vue&type=script&lang=ts"

import "./TheTeachers.vue?vue&type=style&index=0&id=391a71a3&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391a71a3"]])

export default __exports__